import request, { download } from "@/utils/request";
import axios from "axios";
import { getToken } from "@/utils/auth";

// 获取jssdk授权信息
export function getConfigSignature(params = {}) {
  return request({
    url: `/auth/weComSidebar/getConfigSignature`,
    method: "get",
    params,
  });
}

// 获取tree
export function getFolderTree(params = {}) {
  return request({
    url: `/contract/salesTalkFolderConfig/getFolderTree`,
    method: "get",
    params,
  });
}

// 获取话术库
export function tabGetTalkContentList(data = {}) {
  return request({
    url: `/contract/salesTalkFolderConfig/tabGetTalkContentList`,
    method: "post",
    data,
  });
}

// 获取日常素材库
export function tabMaterialActivityList(data = {}) {
  return request({
    url: `/contract/sales-common-material/tabMaterialActivityList`,
    method: "post",
    data,
  });
}

// 获取活动素材库
export function tabMaterialActivityList2(data = {}) {
  return request({
    url: `/contract/marketingMaterialActivity/tabMaterialActivityList`,
    method: "post",
    data,
  });
}

// 任务详情
export function getTaskDetail(data = {}) {
  return request({
    url: `/contract/salesMarketTaskForWeChat/getTaskDetail`,
    method: "post",
    data,
  });
}

// 员工完成执行任务
export function finishTaskExecute(data = {}) {
  return request({
    url: `/contract/salesMarketTaskForWeChat/finishTaskExecute`,
    method: "post",
    data,
  });
}

// 任务详情 授权时获取
export function getTaskDetailForAuth(id = "") {
  return request({
    url: `/contract/salesMarketTaskForWeChat/getTaskDetailForAuth/${id}`,
    method: "post",
  });
}

// 任务授权/拒绝
export function authorizeTask(data = {}) {
  return request({
    url: `/contract/salesMarketTask/authorizeTask`,
    method: "post",
    data,
  });
}

// 点击统计
export function clickLog(url, params) {
  const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: import.meta.env.VITE_APP_BASE_API,
    // 超时
    timeout: 600000,
  });

  return service.get(url, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + getToken(),
    },
    params,
  });
}
